import { render } from "./ParticipantesProtocolo.vue?vue&type=template&id=20907e78&scoped=true"
import script from "./ParticipantesProtocolo.vue?vue&type=script&lang=js"
export * from "./ParticipantesProtocolo.vue?vue&type=script&lang=js"

import "./ParticipantesProtocolo.vue?vue&type=style&index=0&id=20907e78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20907e78"]])

export default __exports__